import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Container, Box, Grid, TextField, Button, CircularProgress, List, ListItem, ListItemText, Divider, } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckIcon from '@material-ui/icons/Check';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CustomBreadcrumbs from '../Breadcrumb';
import { approveBreakDown, getBreakdownDetails, } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';

const ApproveBreakdown = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Pending Approvals', href: '/breakdown-management/pending-approvals' },
    ];
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const breakdown_id = pathname[2];

    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);
    const [breakDownDetails, setBreakdownDetails] = useState();
    const [approverComment, setcomment] = useState("");
    const Role = localStorage.getItem("userRole");


    const approveHandler = async () => {
        if (Role === 'admin' || Role === 'supplier') {
            const payload = {
                breakdown_id: breakdown_id,
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                approval_status: true,
                comment: approverComment
            }
            try {
                setPostLoading(true)
                const action = dispatch(approveBreakDown(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.StatusCode === 201) {
                    setPostLoading(false)
                    toast.success("BreakDown Approved Successfully!");
                    setTimeout(() => {
                        navigate("/breakdown-management");
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        } else {
            toast.info("You don't allow to do this activity!")
        }


    }

    const rejectHandler = async () => {
        if (Role === 'admin' || Role === 'supplier') {
            const payload = {
                breakdown_id: breakdown_id,
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                approval_status: false,
                comment: approverComment
            }
            try {
                setRejectLoading(true)
                const action = dispatch(approveBreakDown(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.StatusCode === 201) {
                    toast.success("BreakDown Rejected Successfully!");
                    setTimeout(() => {
                        navigate("/breakdown-management");
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setRejectLoading(false)
            }
        } else {
            toast.info("You don't allow to do this activity!")
        }

    }

    const getbreakdownDetails = async () => {
        try {
            const action = dispatch(getBreakdownDetails(breakdown_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdownDetails(res.result.breakdown)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getbreakdownDetails();
            setLoading(false);
        };
        fetchData();
    }, [])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Approve/Reject Breakdown" />
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Asset no.
                            <h4>{(breakDownDetails.machine_details.asset_no)?.slice(3)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            Asset Description
                            <h4>{breakDownDetails.machine_details.asset_text}</h4>
                        </Grid>
                        {/* <Grid item xs={6} sm={2}>
                            RFID NO
                            <h4>{breakDownDetails.rfidNo}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Part No
                            <h4>{breakDownDetails.partNo}</h4>
                        </Grid> */}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Nature
                            <h4>{breakDownDetails.reason.category_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Priority
                            <h4>{breakDownDetails.priority}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Failure Reason
                            <h4>{breakDownDetails.reason.name}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={6} sm={2}>
                            Assigned by
                            <h4>{breakDownDetails.status_history[0].status_change_username}</h4>
                        </Grid> */}
                        {Object.keys(breakDownDetails.comments)
                            .filter(commentId => commentId !== 'user_names') // Filter out 'user_names'
                            .map((commentId) => {
                                const commentData = breakDownDetails.comments[commentId];
                                const userName = breakDownDetails.comments.user_names[commentId];
                                // Split the timestamp and comment
                                const [timestamp] = commentData.split(': ');

                                // Format the date using dayjs
                                // const formattedDate = dayjs(timestamp).format("DD MMM, YYYY hh:mm A");

                                return (
                                    <>
                                        <Grid item xs={6} sm={2} key={commentId}>
                                            Assigned by
                                            <h4>{userName}</h4>
                                        </Grid>
                                        <Grid item xs={6} sm={2} key={commentId}>
                                            Assigned at
                                            <h4>{convertUTCtoIST(timestamp)}</h4>
                                        </Grid>
                                    </>
                                );
                            })
                        }

                        {/* <Grid item xs={6} sm={2}>
                            Assigned at
                            <h4>{new Date(breakDownDetails.status_history[0].status_change_timestamp).toLocaleString()}</h4>
                        </Grid> */}
                        <Grid item xs={6} sm={3}>
                            Attended by
                            <h4>{breakDownDetails.attendance[0].attended_username}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Attended at
                            {/* <h4>{dayjs(breakDownDetails.attendance[0].attended_timestamp).format("DD MMM, YYYY hh:mm A")}</h4> */}
                            <h4>{convertUTCtoIST(breakDownDetails.attendance[0].attended_timestamp)}</h4>
                        </Grid>
                    </Grid>

                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Problem observed
                            <h4>--</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Diagnosis
                            <h4>--</h4>
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            Added observations
                            {/* <h4>{breakDownDetails.date}</h4> */}
                            {breakDownDetails && breakDownDetails.attendance.length > 0 && (
                                <List>
                                    {breakDownDetails.attendance.map((attend, index) => {
                                        const timestamp = dayjs(attend.attended_timestamp).format('DD MMM, YYYY hh:mm A');
                                        // Provide a default empty object if observation is null or undefined
                                        // const observationValues = attend.observation ? Object.values(attend.observation) : [];

                                        // // Join observations into a single string if needed
                                        // const observationText = observationValues.length > 0 ? observationValues.join(', ') : 'No observations';
                                        const observation = attend.observation && Object.values(attend.observation);

                                        // Only render the observation if it exists and is not null or empty
                                        if (!observation || observation.length === 0 || observation[0] === null) {
                                            return null;
                                        }
                                        return (
                                            <div key={index}>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`${timestamp} | ${attend.attended_username}`}
                                                        secondary={observation}
                                                    />
                                                </ListItem>
                                                {index < breakDownDetails.attendance.length - 1 && <Divider />}
                                            </div>
                                        );
                                    })}
                                </List>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            Approver's Comment
                            <TextField
                                name="approverComment"
                                value={approverComment}
                                onChange={(e) => setcomment(e.target.value)}
                                fullWidth
                                multiline
                                minRows={4}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box style={{ margin: '0 auto', maxWidth: '850px', marginBottom: "12px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px", backgroundColor: "red", color: "white" }}
                                onClick={rejectHandler}
                                startIcon={rejectLoading ? <CircularProgress size={20} /> : <NotInterestedIcon />}
                                disabled={rejectLoading}
                            >
                                {rejectLoading ? "Rejecting" : "Reject"}
                            </Button>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                onClick={approveHandler}
                                startIcon={postLoading ? <CircularProgress size={20} /> : <CheckIcon />}
                                disabled={postLoading}
                            >
                                {postLoading ? "Approving" : "Approve"}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box className="checkpoint-box" mb={3}>
                    {<Grid container spacing={2}>
                        
                        <Grid item xs={6} sm={4}>
                            Comments
                        </Grid>
                    </Grid>}
                </Box> */}
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        {Object.keys(breakDownDetails.comments)
                            .filter(commentId => commentId !== 'user_names') // Filter out 'user_names'
                            .map((commentId) => {
                                const commentData = breakDownDetails.comments[commentId];
                                const userName = breakDownDetails.comments.user_names[commentId];

                                // Split the timestamp and comment
                                const [timestamp, comment] = commentData.split(': ');

                                // Format the date using dayjs
                                // const formattedDate = dayjs(timestamp).format("DD MMM, YYYY hh:mm A");

                                return (
                                    <Grid item xs={12} sm={12} key={commentId}>
                                        Comments
                                        <h4>{convertUTCtoIST(timestamp)} - {comment} (by {userName})</h4>
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </Box>

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default ApproveBreakdown;
